const API_BASE_URL = 
  typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'https://api.neogtm.com'
    : 'https://api.neogtm.com';

/**
 * LinkedIn profile image URLs on licdn.com usually 403/404 when hotlinked from our app,
 * which spams the devtools console with failed GETs. Skip <img src> for these; use initials
 * until a hosted/proxied URL exists.
 */
export function isLikelyBlockedLinkedInCdnImageUrl(url: string | null | undefined): boolean {
  if (!url || typeof url !== 'string') return false;
  const trimmed = url.trim();
  if (!trimmed) return false;
  try {
    const base = typeof window !== 'undefined' ? window.location.href : 'http://localhost';
    const h = new URL(trimmed, base).hostname.toLowerCase();
    return h === 'media.licdn.com' || h === 'static.licdn.com' || h.endsWith('.licdn.com');
  } catch {
    return false;
  }
}

// Track reported photos to avoid duplicate reports
const reportedPhotos = new Set<string>();

export async function reportBrokenPhoto(personId: string): Promise<void> {
  if (!personId || reportedPhotos.has(personId)) {
    return;
  }

  reportedPhotos.add(personId);

  try {
    await fetch(`${API_BASE_URL}/api/photos/report-broken`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ person_id: personId }),
    });
  } catch (error) {
    if (import.meta.env.DEV) {
      console.warn('Failed to report broken photo:', error);
    }
  }
}

export function getPhotoUrl(hostedPhotoUrl?: string | null, linkedinPhotoUrl?: string | null): string | null {
  return hostedPhotoUrl || linkedinPhotoUrl || null;
}

export function getInitials(firstName?: string, lastName?: string, fullName?: string): string {
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }
  if (fullName) {
    const parts = fullName.trim().split(/\s+/);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return fullName.substring(0, 2).toUpperCase();
  }
  return '??';
}

